import { Col, Form, Input, Row } from 'antd';
import React, { useMemo } from 'react';
import { Colors } from '@common/tokens';

const formItemStyle = { margin: 0 };
const colStyle = { marginTop: '8px' };

export const DisputeCommentInput = ({
  containerStyle = { marginTop: '24px' },
  placeholder = 'Please enter details for this dispute',
  creationType,
  required,
}: {
  containerStyle?: { marginTop: string };
  placeholder?: string;
  creationType?: boolean;
  required?: boolean;
}) => {
  const effectiveRequired = required ?? true;
  const rules = useMemo(() => {
    const message = creationType
      ? 'Please enter a reason'
      : 'Please enter a comment';

    return [{ required: effectiveRequired, message }];
  }, [creationType, effectiveRequired]);

  return (
    <>
      <Row style={containerStyle} className="DisputeCommentInput">
        <Col span={24}>
          <span className="dispute-label">
            {effectiveRequired && (
              <span className="required-field" style={{ color: Colors.coral }}>
                *{' '}
              </span>
            )}
            {creationType ? 'Dispute Reason' : 'Comment'}
          </span>
        </Col>
        <Col span={24} style={colStyle}>
          <Form.Item name="comment" rules={rules} style={formItemStyle}>
            <Input.TextArea
              size="large"
              rows={3}
              cols={2}
              style={{ resize: 'none' }}
              className="sra-large-input"
              placeholder={placeholder}
            />
          </Form.Item>
        </Col>
      </Row>
      <style jsx>{`
        :global(.DisputeCommentInput .dispute-label) {
            font-weight: 600;
          }
        }
      `}</style>
    </>
  );
};
